import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-16 min-h-screen flex items-center justify-center bg-background-50">
        <div className="text-center px-4 py-20">
          <div className="text-7xl md:text-9xl font-heading font-bold text-primary-500 mb-4">404</div>
          <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-3">
            页面未找到
          </h1>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
            您访问的页面不存在或已被移除。不如回到首页继续吃瓜吧！
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-medium text-sm transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}